
import { Component, Vue } from "vue-property-decorator";

@Component
export default class CaseNotification extends Vue {
  isActive = localStorage.getItem("case_profile_notification_active") !== "false";

  get text() {
    return `${this.$t("text.start")} <br/> ${this.$t("text.end")}`;
  }

  hideNotification() {
    this.isActive = false;

    localStorage.setItem("case_profile_notification_active", "false");
  }
}
